import { animate, query, stagger, style, transition, trigger, state } from '@angular/animations';

// Design System Standard Timings
const TIMING_FAST = '150ms cubic-bezier(0.4, 0, 0.2, 1)';
const TIMING_NORMAL = '300ms cubic-bezier(0.4, 0, 0.2, 1)';

export const listAnimation = trigger('listAnimation', [
  transition('* => *', [
    query(':enter', [
      style({ opacity: 0, transform: 'translateY(8px)' }),
      stagger('40ms', [
        animate(TIMING_NORMAL, style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ], { optional: true })
  ])
]);

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate(TIMING_FAST, style({ opacity: 1 }))
  ]),
  transition(':leave', [
    animate(TIMING_FAST, style({ opacity: 0 }))
  ])
]);

export const expandCollapse = trigger('expandCollapse', [
  state('collapsed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
  state('expanded', style({ height: '*', opacity: 1 })),
  transition('collapsed <=> expanded', [
    animate(TIMING_NORMAL)
  ])
]);

export const slideDownUp = trigger('slideDownUp', [
  transition(':enter', [
    style({ height: '0px', opacity: 0, overflow: 'hidden' }),
    animate(TIMING_NORMAL, style({ height: '*', opacity: 1 }))
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 1, overflow: 'hidden' }),
    animate(TIMING_NORMAL, style({ height: '0px', opacity: 0 }))
  ])
]);

export const scaleIn = trigger('scaleIn', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.98)' }),
    animate(TIMING_NORMAL, style({ opacity: 1, transform: 'scale(1)' }))
  ])
]);

/** Painel entra da direita para a esquerda (ex.: drawer). */
export const slideInRight = trigger('slideInRight', [
  transition(':enter', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate('340ms cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateX(0)', opacity: 1 })),
  ]),
  transition(':leave', [
    animate('280ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateX(100%)', opacity: 0 })),
  ]),
]);

export const slidePage = trigger('slidePage', [
  transition(':increment', [
    style({ position: 'relative', overflow: 'hidden' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ transform: 'translateX(100%)', opacity: 0 })
    ], { optional: true }),
    query(':leave', [
      animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateX(-100%)', opacity: 0 }))
    ], { optional: true }),
    query(':enter', [
      animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateX(0%)', opacity: 1 }))
    ], { optional: true }),
  ]),
  transition(':decrement', [
    style({ position: 'relative', overflow: 'hidden' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ transform: 'translateX(-100%)', opacity: 0 })
    ], { optional: true }),
    query(':leave', [
      animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateX(100%)', opacity: 0 }))
    ], { optional: true }),
    query(':enter', [
      animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateX(0%)', opacity: 1 }))
    ], { optional: true }),
  ]),
]);